var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinux(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2169,
    height: 2500,
    viewBox: "0 0 256 295",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "48.548%",
    y1: "115.276%",
    x2: "51.047%",
    y2: "41.364%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDBFC2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "54.407%",
    y1: "2.404%",
    x2: "46.175%",
    y2: "90.542%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.8,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "51.86%",
    y1: "88.248%",
    x2: "47.947%",
    y2: "9.748%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDBFC2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.925%",
    y1: "85.49%",
    x2: "49.924%",
    y2: "13.811%",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDBFC2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "53.901%",
    y1: "3.102%",
    x2: "45.956%",
    y2: "93.895%",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.65,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.593%",
    y1: "5.475%",
    x2: "54.811%",
    y2: "93.524%",
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.65,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.984%",
    y1: "89.845%",
    x2: "49.984%",
    y2: "40.632%",
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDBFC2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "53.505%",
    y1: "99.975%",
    x2: "42.746%",
    y2: "23.545%",
    id: "i"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDBFC2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.841%",
    y1: "13.229%",
    x2: "50.241%",
    y2: "94.673%",
    id: "j"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.8,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.927%",
    y1: "37.327%",
    x2: "50.727%",
    y2: "92.782%",
    id: "k"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.65,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.876%",
    y1: "2.299%",
    x2: "49.876%",
    y2: "81.204%",
    id: "l"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.65,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.833%",
    y1: "2.272%",
    x2: "49.824%",
    y2: "71.799%",
    id: "m"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.65,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "53.467%",
    y1: "48.921%",
    x2: "38.949%",
    y2: "98.1%",
    id: "n"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA63F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.373%",
    y1: "143.009%",
    x2: "47.579%",
    y2: "-64.622%",
    id: "o"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDBFC2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "30.581%",
    y1: "34.024%",
    x2: "65.887%",
    y2: "89.175%",
    id: "p"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA63F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "59.572%",
    y1: "-17.216%",
    x2: "48.361%",
    y2: "66.118%",
    id: "q"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.65,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "47.769%",
    y1: "1.565%",
    x2: "51.373%",
    y2: "104.313%",
    id: "r"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.65,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.55%",
    y1: "4.533%",
    x2: "57.114%",
    y2: "92.827%",
    id: "s"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.65,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.733%",
    y1: "17.609%",
    x2: "50.558%",
    y2: "99.385%",
    id: "t"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA63F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.17%",
    y1: "2.89%",
    x2: "49.68%",
    y2: "94.17%",
    id: "u"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.65,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.125 249.359c0 17.355-52.617 31.497-117.54 31.497S.044 266.806.044 249.359c0-17.356 52.618-31.498 117.54-31.498 64.924 0 117.45 14.142 117.541 31.498z",
    fill: "#000",
    fillOpacity: 0.2,
    filter: "url(#a)",
    transform: "translate(10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.213 215.474c-11.387-16.346-13.591-69.606 12.947-102.39C89.292 97.383 92.69 86.455 93.7 71.67c.734-16.805-11.846-66.851 35.537-70.616 48.027-3.857 45.364 43.526 45.088 68.596-.183 21.12 15.52 33.15 26.355 49.68 19.927 30.303 18.274 82.461-3.765 110.745-27.916 35.354-51.791 20.018-67.678 21.304-29.752 1.745-30.762 17.54-66.024-35.905z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.1 122.451c8.265 7.622 29.661 41.69-4.224 62.995-11.937 7.438 10.653 35.721 21.488 22.039 19.193-24.61 6.98-63.913-4.591-77.963-7.714-9.917-19.651-13.774-12.672-7.07z",
    fill: "url(#b)",
    transform: "translate(10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.805 117.86c13.59 11.02 38.292 49.587 2.204 74.748-11.846 7.806 10.468 32.508 23.049 19.927 43.618-43.894-1.102-94.308-16.53-111.664-13.774-15.151-25.987 3.49-8.723 16.989z",
    stroke: "#000",
    strokeWidth: 0.977,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.245 25.02c-.459 12.581-14.325 23.51-30.946 24.52-16.621 1.01-29.66-8.54-29.202-21.121.46-12.581 14.326-23.509 30.947-24.519 16.62-.918 29.66 8.54 29.201 21.12z",
    fill: "url(#c)",
    transform: "translate(10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.483 54.957c.46 8.173-3.397 15.06-8.723 15.335-5.326.276-10.01-6.06-10.469-14.233-.459-8.173 3.398-15.06 8.724-15.335 5.326-.276 10.01 6.06 10.468 14.233z",
    fill: "url(#d)",
    transform: "translate(10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.125 55.6c.184 9.458 6.337 16.988 13.683 16.805 7.346-.184 13.131-7.99 12.948-17.54-.184-9.458-6.336-16.988-13.683-16.804-7.346.183-13.223 8.08-12.948 17.539z",
    fill: "url(#e)",
    transform: "translate(10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.186 57.712c-.092 5.234 2.48 9.458 5.877 9.458 3.306 0 6.153-4.224 6.245-9.366.091-5.234-2.48-9.459-5.878-9.459-3.397 0-6.152 4.225-6.244 9.367zM111.974 57.804c.459 4.316-1.194 7.989-3.582 8.356-2.387.276-4.683-2.938-5.142-7.254-.46-4.316 1.194-7.99 3.581-8.357 2.388-.275 4.684 2.939 5.143 7.255z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.564 54.773c-.276 2.939 1.102 5.326 3.03 5.51 1.928.184 3.765-2.112 4.04-4.959.276-2.938-1.102-5.326-3.03-5.51-1.928-.183-3.765 2.113-4.04 4.96z",
    fill: "url(#f)",
    transform: "translate(10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.953 55.508c.276 2.388-.734 4.5-2.203 4.683-1.47.184-2.847-1.653-3.123-4.132-.275-2.388.735-4.5 2.204-4.683 1.47-.184 2.847 1.744 3.122 4.132z",
    fill: "url(#g)",
    transform: "translate(10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.027 145.684c6.52-14.785 20.386-40.772 20.662-60.883 0-15.978 47.843-19.835 51.7-3.856 3.856 15.978 13.59 39.853 19.834 51.424 6.245 11.478 24.335 48.118 5.051 80.074-17.356 28.284-69.973 50.69-98.073-3.856-9.55-18.917-7.806-42.333.826-62.903z",
    fill: "url(#h)",
    transform: "translate(10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.15 134.664c-5.601 10.56-17.172 38.293 11.112 53.445 30.395 16.162 30.303 49.312-6.245 33.517-33.425-14.233-18.641-71.902-9.274-85.676 6.06-9.642 15.243-21.488 4.407-1.286z",
    fill: "url(#i)",
    transform: "translate(10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.925 122.727c-8.907 14.509-30.211 48.669-1.652 66.484 38.384 23.6 27.548 47.108-7.53 25.895-49.404-29.568-5.97-89.257 13.774-112.03 22.59-25.529 4.316 4.683-4.592 19.65z",
    stroke: "#000",
    strokeWidth: 1.25,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.428 151.285c0 16.162-15.519 37.1-42.15 36.916-27.456.183-39.118-20.754-39.118-36.916 0-16.161 18.182-29.293 40.588-29.293 22.498.092 40.68 13.132 40.68 29.293z",
    fill: "url(#j)",
    transform: "translate(10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.92 100.504c-.276 16.713-11.204 20.662-24.978 20.662-13.775 0-23.784-2.48-24.978-20.662 0-11.387 11.203-17.998 24.978-17.998 13.774-.092 24.977 6.52 24.977 17.998z",
    fill: "url(#k)",
    transform: "translate(10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.63 126.216c9-13.682 28.008-34.711 3.582 2.939-19.835 31.038-7.346 50.965-.918 56.474 18.549 16.53 17.814 27.64 3.214 18.917-31.314-18.641-24.794-50.047-5.878-78.33z",
    fill: "url(#l)",
    transform: "translate(10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.936 131.818c-7.806-16.07-32.6-56.842 1.193-9.459 30.763 42.884 9.183 72.729 5.326 75.667-3.856 2.939-16.804 8.908-13.04-1.469 3.858-10.377 22.958-30.028 6.52-64.74z",
    fill: "url(#m)",
    transform: "translate(10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.835 258.542c-20.57-10.928-50.414 2.112-39.578-27.457 2.204-6.704-3.214-16.805.275-23.325 4.133-7.989 13.04-6.244 18.366-11.57 5.234-5.51 8.54-15.06 18.366-13.59 9.734 1.468 16.254 13.406 23.049 28.099 5.05 10.468 22.865 25.253 21.672 37.007-1.47 17.998-21.948 21.396-42.15 10.836z",
    stroke: "#E68C3F",
    strokeWidth: 6.25,
    fill: "url(#n)",
    transform: "translate(10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.608 189.119c-3.122 5.877-16.162 15.335-24.886 12.856-8.815-2.388-12.856-15.795-11.111-25.988 1.653-11.386 11.111-12.03 23.05-6.336 12.855 6.336 16.712 11.662 12.947 19.468z",
    fill: "url(#o)",
    transform: "translate(10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.445 253.49c15.06-18.273 48.578-14.508 25.988-39.577-4.775-5.418-3.306-16.989-9.183-21.947-6.887-6.061-14.509-1.102-21.488-4.224-6.979-3.398-14.325-9.918-22.865-5.327-8.54 4.684-9.459 16.805-10.285 32.783-.735 11.479-11.203 30.671-5.602 41.231 8.081 16.346 29.11 14.142 43.435-2.938z",
    stroke: "#E68C3F",
    strokeWidth: 6.251,
    fill: "url(#p)",
    transform: "translate(10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.925 229.064c23.325-34.435 5.97-34.16.092-36.823-5.877-2.755-12.03-8.173-18.916-4.408-6.888 3.857-7.255 13.775-7.439 26.814-.275 9.367-8.08 25.07-3.397 33.793 5.693 10.193 19.467-4.591 29.66-19.376z",
    fill: "url(#q)",
    transform: "translate(10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.06 234.023c-34.895-22.59-18.55-30.303-13.315-33.885 6.336-4.591 6.428-13.407 14.233-12.58 7.806.826 12.397 10.468 17.631 22.406 3.857 8.54 17.264 19.927 16.254 29.753-1.285 11.57-19.743 3.948-34.803-5.694z",
    fill: "url(#r)",
    transform: "translate(10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.588 188.843c-2.755 4.776-13.958 12.306-21.396 10.285-7.622-1.928-11.112-12.672-9.55-20.753 1.377-9.183 9.55-9.642 19.834-5.05 10.928 4.958 14.326 9.182 11.112 15.518z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.058 186.18c-1.745 3.306-9.091 8.54-14.234 7.163-5.142-1.377-7.713-8.815-6.887-14.417.735-6.336 6.244-6.704 13.223-3.581 7.53 3.49 9.918 6.428 7.898 10.835z",
    fill: "url(#s)",
    transform: "translate(10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.107 66.344c3.673-3.398 12.58-13.774 29.477-2.939 3.122 2.02 5.693 2.204 11.662 4.775 12.03 4.96 6.336 16.897-6.52 20.937-5.51 1.745-10.468 8.449-20.386 7.806-8.54-.46-10.744-6.06-15.978-9.091-9.275-5.234-10.652-12.305-5.602-16.07 5.051-3.765 6.98-5.143 7.347-5.418z",
    stroke: "#E68C3F",
    strokeWidth: 3.75,
    fill: "url(#t)",
    transform: "translate(10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.43 75.986c-5.05.275-15.979 11.203-27.457 11.203-11.479 0-18.366-10.652-20.11-10.652",
    stroke: "#E68C3F",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.8 65.426c1.837-1.653 7.622-6.153 15.244-1.562 1.653.919 3.306 1.929 5.693 3.306 4.867 2.847 2.48 6.98-3.398 9.55-2.663 1.102-7.07 3.49-10.376 3.306-3.673-.367-6.153-2.755-8.54-4.316-4.5-2.938-4.224-5.418-2.112-7.346 1.56-1.47 3.305-2.847 3.49-2.938z",
    fill: "url(#u)",
    transform: "translate(10)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinux);
export default __webpack_public_path__ + "static/media/linux.dd224829f1c9796dec4a72702d7cb764.svg";
export { ForwardRef as ReactComponent };